import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import Store from "./store/store";

import ScrollToTop from "./hoc/scrollToTop";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// --- Note ---

//* BrowserRouter :: Used for client-side routing
// - when the GET req is hits the server than it should return the index.html file only cos that is handling the routing n not the server
//! - Server should be configured to handle the req cos only index.html file is returned for all req

//* HashRouter :: Used for sever-side routing
// this is used to avoid server side req (as config is req at server-side to send same file)
// used as example.com/#/eg; # is used to prevent from sending that GET req

ReactDOM.render(
    <React.StrictMode>
        <Provider store={Store}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <ScrollToTop>
                    <App />
                </ScrollToTop>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
